import React from "react";
import * as Icon from "react-bootstrap-icons";
import {NavLink, useNavigate} from "react-router-dom";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import * as Utils from "../../inc/Utils";
import {Config} from "../../Config";
import * as XLSX from 'xlsx';
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";

export default function AdsNamingCreativeAlwaysImport() {
    const roles = new Role();
    let userId = roles.loginUserId;
    const navigate = useNavigate();

    let btnTextDefault = 'ดาวน์โหลดเทมเพลต';
    let btnTextLoading = 'กำลังดาวน์โหลด..';
    let [isLoading, setLoading] = React.useState(false);

    let btnTextUploadDefault = 'อัพโหลด';
    let btnTextUploading = 'กำลังอัพโหลด..';
    let [isUploading, setUploading] = React.useState(false);
    let [isUploaded, setUploaded] = React.useState(false);

    let btnTextImportDefault = 'นำเข้าระบบ';
    let btnTextImporting = 'กำลังนำเข้า..';
    let [isImporting, setImporting] = React.useState(false);

    let [showExcelPreview, setExcelPreview] = React.useState('');
    let [showExcelPreviewError, setExcelPreviewError] = React.useState('');
    let [excelFile, setExcelFile] = React.useState(false);
    let [disableImport, setDisableImport] = React.useState(true);

    const onDownload = () => {
        let typeName = '';
        let data = [{
            "Content Pillar": "",
            "Creative Name": ""
        }];

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "adsNamingCreativeAlways_" + typeName + "_" + Utils.getDate() + ".xlsx");
    };

    const onSelectFile = (e) => {
        setExcelFile(e);
    };

    async function getPillarByName(name) {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingContentPillar/byName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                name: name
            })
        });

        return response.json()
    }

    const resetUpload = () => {
        window.location.reload();
    };

    const onUpload = async () => {
        if(!excelFile || typeof excelFile.target === 'undefined' || excelFile.target.files.length === 0) {
            toast.error("กรุณาระบุ Excel File");
        }
        else {
            setUploading(true);
            setExcelPreview('');

            const [file] = excelFile.target.files;
            const reader = new FileReader();

            reader.onload = async (evt) => {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: "binary" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });

                if(data) {
                    let row = data.split('\n');
                    //Check Header
                    let header = row[0];
                    let cols = header.split(',');
                    if(cols[0] !== 'Content Pillar') {
                        setUploading(false);
                        toast.error("Column 1 : ต้องเป็น(ชื่อ) Content Pillar");
                        return;
                    }
                    else if(cols[1] !== 'Creative Name') {
                        setUploading(false);
                        toast.error("Column 2 : ต้องเป็น(ชื่อ) Creative Name");
                        return;
                    }
                    else {
                        let statusAll = [];
                        let dataList = [];
                        let dataListError = [];
                        for(let i=1;i<row.length;i++) {
                            let cols = row[i].split(',');
                            let colPillar = cols[0].toString().trim();
                            let colCreative = cols[1].toString().trim();
                            if(!colPillar && !colCreative) {
                                toast.error("ยังไม่ได้ระบุข้อมูล");
                                return;
                            }
                            else {
                                let status = 0;
                                const dataResult = await getPillarByName(colPillar);
                                if(dataResult && dataResult.id && colPillar && colCreative) {
                                    status = 1;
                                    dataList.push({
                                        pillarName: colPillar,
                                        creativeName: colCreative,
                                        status: status
                                    });
                                }
                                else {
                                    status = 2;
                                    dataListError.push({
                                        pillarName: colPillar,
                                        creativeName: colCreative,
                                        status: status
                                    });
                                }
                                statusAll.push(status);
                            }
                        }
                        setUploading(false);
                        setUploaded(true);
                        setExcelPreview(dataList);
                        setExcelPreviewError(dataListError);
                        if(statusAll.includes(2) || statusAll.includes(0)) {
                            setDisableImport(true);
                        }
                        else {
                            setDisableImport(false);
                        }

                        toast.success("Generate Result เรียบร้อย");
                    }
                }
            };
            reader.readAsBinaryString(file);
        }
    };

    const onGenerate = () => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        setImporting(true);

                        for(let rs of showExcelPreview) {

                            const dataResult = await getPillarByName(rs.pillarName);
                            let params = rs.pillarName + '_' + rs.creativeName;

                            const body = {
                                adsNamingContentPillarId: dataResult.id,
                                adsNamingContentPillarText: rs.pillarName,
                                name: rs.creativeName,
                                params: params,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            fetch(Config.url.API_URL +'/api/adsNamingCreativeAlways/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    //toast.success("บันทึกข้อมูลเรียบร้อย");
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            });
                        }
                        setImporting(false);

                        toast.success("บันทึกข้อมูลเรียบร้อย");
                        setTimeout(function () {
                            navigate('/adsNamingCreativeAlways', {replace: true});
                        }, 1500);
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Ads Naming Creative Always</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                    <NavLink className="btn btn-sm btn-light me-2" to='/utmGenerate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <h5><Icon.Upload size={16} /> Export Empty Template</h5>
                    <div className="col-12">
                        <form className="row g-3">
                            <div className="col-12 col-md-6">
                                <button type="button" className="btn btn-success" onClick={onDownload}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span>{isLoading ? btnTextLoading : btnTextDefault}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* ----- UPLOAD ----- */}
            <div className="rounded bg-white p-4 shadow mt-3">
                <div className="row">
                    <h5><Icon.Download size={16} /> Import Template Data</h5>
                    <div className="col-12">
                        <form className="row g-3">
                            <div className={"col-12 col-md-8 " + (disableImport ? 'd-block':'d-none')}>
                                <label htmlFor="excelFilex" className="form-label">Excel File <span className="text-danger">*</span></label>
                                    {
                                        !isUploaded ?
                                            <div className="row">
                                            <div className="col-8 ">
                                                <div className="input-group mb-3">
                                                    <input type="file" className="form-control" id="excelFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => {onSelectFile(e)}} />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <button type="button" className="btn btn-primary" onClick={onUpload} disabled={isUploading}><span
                                            className={isUploading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isUploading ? btnTextUploading : btnTextUploadDefault}</button>
                                            <button type="button" className={"btn btn-secondary " + (!isUploaded ? 'd-none':'d-block')} onClick={resetUpload}>เริ่มใหม่</button>
                                            </div>
                                        </div> : <div className="row"><div className="col-4"><button type="button" className="btn btn-secondary" onClick={resetUpload}>เริ่มใหม่</button></div></div>
                                    }
                            </div>

                            <div className="col-12">
                                <div className="fw-bold py-2 ps-2 bg-green-light">Generate Result</div>
                                <div style={{maxHeight: '600px', overflowY: 'auto'}}>
                                    <table className={"table table-bordered table-green" + (showExcelPreview ? '':' d-none')}>
                                        <thead>
                                        <tr>
                                            <th width="100">Content Pillar <span className="text-danger">*</span></th>
                                            <th width="100">Creative Name <span className="text-danger">*</span></th>
                                            <th className="text-center" width="60">Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            showExcelPreviewError.length ?
                                                showExcelPreviewError.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className="text-danger">{row.pillarName}</td>
                                                        <td>{row.creativeName}</td>
                                                        <td className="text-center text-danger">{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        {
                                            showExcelPreview.length ?
                                                showExcelPreview.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td>{row.pillarName}</td>
                                                        <td>{row.creativeName}</td>
                                                        <td className="text-center text-success">{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="mt-3">
                                    <button type="button" className={"btn btn-success " + (disableImport ? ' d-none':'')} onClick={onGenerate} disabled={isImporting}><span
                                        className={isImporting ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> <Icon.CloudArrowUp siize={16} /> {isImporting ? btnTextImporting : btnTextImportDefault}</button>
                                    <button type="button" className={"ms-3 btn btn-secondary " + (disableImport ? 'd-none':'d-inline-block')} onClick={resetUpload}>เริ่มใหม่</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
}